import { configureStore } from '@reduxjs/toolkit'
import navigationSlice from '../../store/navigation'
import { createManagedCollection } from '../../vendor/react-relaxful/relax/collectionCreator'

export const obituaryStore = createManagedCollection(null, {
    obituaryGallery: 'widget/obituary',
    obituaryFull: 'widget/obituary'
})

const reducers = {}
Object.entries(obituaryStore).forEach(([name, entity]) => (reducers[`${name}Reducer`] = entity.reducer))

/**
 * Root Redux Store
 */
export const store = configureStore({
    reducer: {
        ...{ navigation: navigationSlice },
        ...reducers
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
    devTools: import.meta.env.VITE_APP_ENV !== 'production',
})
